import { TransitProgram } from './transit-program';
import { Provider } from './provider';
import { ProviderFeeScheduleApprovalStatus } from './provider-fee-schedule-approval-status';
import { ProviderServiceLevel } from './provider-service-level';
import { autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(Provider)
export class ProviderDetail extends Provider {
  @autoserializeAs(TransitProgram)
  transitPrograms: Array<TransitProgram>;

  @autoserializeAs(ProviderFeeScheduleApprovalStatus)
  providerFeeSchedules: Array<ProviderFeeScheduleApprovalStatus>;

  @autoserializeAs(ProviderServiceLevel)
  providerServiceLevels: Array<ProviderServiceLevel>;
}
